/**
 * filters.js
 */
$(function () {

/**
 * Sales Index
 */
$('#filterDates').click(event => {
  event.preventDefault(event);

  let request = { location: $('#location_slug').val()};

  let redirect_route = $('#filterDates').attr('data-route');

  if ($('#fromDate').val()) {
    request.from = $('#fromDate').val();
  }
  if ($('#toDate').val()) {
    request.to = $('#toDate').val();
  }

  window.location.href = route(redirect_route, request);
});

$('#clearDates').click(event => {
  $('#fromDate').val('');
  $('#toDate').val('');
});

}); // $(function () {
